import { IRootState } from '../../../store'

export const isServiceConfigurationLoadingSelector = (state: IRootState): boolean =>
  state.configurations.isServiceConfigLoading
